import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import { useHistory, useLocation } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { formatJpDateFromString, getAnnualFeeStatusName } from "../libs/utilsLib";
import { Auth, API } from "aws-amplify";
import { onError } from "../libs/errorLib";
import AdminLeftMenu from "./AdminLeftMenu";
import BasicDomainItems from "./BasicDomainItems";
import ExpertDomainItems from "./ExpertDomainItems";
import "./Admin.css";
import "../admin.css";

export default function AdminReports() {
  const [fees, setFees] = useState([]);
  const [member, setMember] = useState(null);
  const [mNum, setMNum] = useState('M-0000000');
  const [adDate, setAdDate] = useState(''); 
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [paymentData, setPaymentData] = useState({});

  const [refreshCount, setRefreshCount] = useState(0);

  const memTypeItems = [
      '正会員',
      '准会員',
      '正会員（准会員より移行）',
      '名誉会員'
  ];

  const search = useLocation().search;
  let mi = new URLSearchParams(search).get('mid');
  let afy = new URLSearchParams(search).get('y');
  useEffect(() => {
    console.log('useEffect called...');
    const onLoad = async () => {
      try {
        console.log('onLoad called...');
        const user = await Auth.currentCredentials();
        console.log(user);

        const m = await API.get("sakurajima", `/members/${mi}`); 
        setMember(m);
        setMNum(m.memberId);
        console.log('member...');
        console.log(m);
        const fs = await loadFees();
        console.log(fs);
        let pd = {}; // payment data
        for (const f of fs) {
          pd[f.data] = { status:f.status, dateOfPayment: (f.dateOfPayment == 'HaveNotMadeAPayment' ? "" : f.dateOfPayment) };
          console.log(f);
        }
        setPaymentData(pd);
        setFees(fs);
        const fy = currentFiscalYear();
        console.log('fiscal year: ' + fy);
        console.log(typeof fy);
        setFiscalYear(fy);
      } catch (e) {
        onError(e);
      }
    };
    onLoad();
  },[refreshCount]);

  function loadFees() {
    console.log(`/fees?mid=${mi}&afy=${afy}`);
    return API.get("sakurajima", `/fees/${mi}`); 
  }

  const { userProfile } = useAppContext();
  
  const [fields, messages, handleFieldChange, doValidation] = useFormFields({
    sMemNumber: "",
    sJoinYBegin: "",
    mAffiliationName: "",
    mBasicDomain: "",
    mExpertDomain: "",
    mCert1Selects: "",
    mDegree: "",
    sYearOfFee: "",
    orderBy: "1",
    ascOrDesc: "1",
    mLimit: "50",
    updateStatus: "0",
  },
  {
    sMemNumber: {n:"", f: (value) => { return '' }},
    sJoinYBegin: {n:"", f: (value) => { return '' }},
    mAffiliationName: {n:"", f: (value) => { return '' }},
    mBasicDomain: {n:"", f: (value) => { return '' }},
    mExpertDomain: {n:"", f: (value) => { return '' }},
    mCert1Selects: {n:"", f: (value) => { return '' }},
    mDegree: {n:"", f: (value) => { return '' }},
    sYearOfFee: {n:"", f: (value) => { return '' }},
    orderBy: {n:"", f: (value) => {  return '' }},
    ascOrDesc: {n:"", f: (value) => { return '' }},
    mLimit: {n:"", f: (value) => { return '' }},
    updateStatus: {n:"", f: (value) => { return '' }},
  });

  // mTypes checkbox
  const [mTypes, setMTypes] = useState([0,0,0,0]);
  // mClasses checkbox
  const [mClasses, setMClasses] = useState([0,0,0,0]);
  // mPositions checkbox
  const [mPositions, setMPositions] = useState([0,0,0,0,0]);
  // mCommittees checkbox
  const [mCommittees, setMCommittees] = useState([0,0,0,0,0,0,0,0,0,0]);
  // mCommittees checkbox
  const [mRepresentative, setMRepresentative] = useState([0]);
  // mCert2Checks checkbox
  const [mCert2Checks, setMCert2Checks] = useState([0,0,0,0,0,0,0,0,0,0,0,0]);
  // mAnnualFees checkbox
  const [mAnnualFees, setMAnnualFees] = useState([0,0]);
  const [dateOfPayment, setDateOfPayment] = useState("");
  const [afYear, setAfYear] = useState("");
  const [afStatus, setAfStatus] = useState("0");
  const [fiscalYear, setFiscalYear] = useState(2020);

  function handleSearch(event) {
    console.log('handleSearch');
  }

  function handleView(e) {
    e.preventDefault();
    const pk = e.target.getAttribute('pk');
    history.push(`/members/${pk}`);
  }

 function handleEdit(e) {
    e.preventDefault();
    const pk = e.target.getAttribute('pk');
    history.push(`/editMembers/${pk}`);
 }

 function handleMTypesChange(event) {
    const n = event.target.name;
//    console.log(n.substring('mCommittees'.length));
    const i = parseInt(n.substring('mTypes'.length));
    let chs = JSON.parse(JSON.stringify(mTypes));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMTypes(chs);
  }

  function handleMClassesChange(event) {
    console.log('handleMClassesChange..');
    const n = event.target.name;
    const i = parseInt(n.substring('mClasses'.length));
    let chs = JSON.parse(JSON.stringify(mClasses));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMClasses(chs);
  }

  function handleMPositionsChange(event) {
    console.log('handleMPositionsChange..');
    const n = event.target.name;
    const i = parseInt(n.substring('mPositions'.length));
    let chs = JSON.parse(JSON.stringify(mPositions));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMPositions(chs);
  }

  function handleMCommitteesChange(event) {
    console.log('handleMCommitteesChange..');
    const n = event.target.name;
    const i = parseInt(n.substring('mCommittees'.length));
    let chs = JSON.parse(JSON.stringify(mCommittees));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMCommittees(chs);
  }

  function handleMRepresentativeChanges(event) {
    console.log('handleMRepresentative..');
    const n = event.target.name;
    const i = parseInt(n.substring('mRepresentative'.length));
    let chs = JSON.parse(JSON.stringify(mRepresentative));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMRepresentative(chs);
  }

  function handleMAnnualFeesChange(event) {
    console.log('handleMAnnualFeesChange..');
    const n = event.target.name;
    const i = parseInt(n.substring('mAnnualFees'.length));
    let chs = JSON.parse(JSON.stringify(mAnnualFees));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMAnnualFees(chs);
  }

  function handleCert2ChecksChange(event) {
    console.log('handleCert2ChecksChange..');
    const n = event.target.name;
    const i = parseInt(n.substring('mCert2Checks'.length));
    let chs = JSON.parse(JSON.stringify(mCert2Checks));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMCert2Checks(chs);
  }


  const getStatusName = (state) => {
      if (1 == state)
	  return '入金済';
      else if (2 == state)
	  return '未入金';
      else
          return '';
  };

  const getMemberId = (data, onlyYear) => {
    const d = data.split('#');
    if (onlyYear) 
      return d[1];
    else
      return d[1] + '年度会員';
  };

  const checkDateOfPayment = (dop) => {
    const arr = dop.split('/');
    if (arr.length != 3) {
      onError(dop + ' → 2021/06/07 の形式で入力してください。');
      return false;
    }
    if (!(arr[0].length == 4 && arr[1].length == 2 && arr[2].length == 2)) {
      onError(dop + ' → 2021/06/07 の形式で入力してください。');
      return false;
    }
    return true;
  };
    
  const handleUpdateAnnualFee = async (event) => { 
    console.log('handleUpdateAnnualFee...');
    var key = event.target.id.split('-')[1];
    console.log(key);
    console.log(paymentData[key]);
    let body = [];

    const keyArr = key.split('#');
    console.log(paymentData[key].data);
    if (paymentData[key].status == 1 && paymentData[key].dateOfPayment.length == 0) {
        onError('入金済を指定した場合は入金日を必ず入力してください。');
        return false;
    }
    if(paymentData[key].dateOfPayment.length > 0 && !checkDateOfPayment(paymentData[key].dateOfPayment)) return false;
    body.push({
      pk: `${mi}#${keyArr[1]}`,
      status: paymentData[key].status,
      dateOfPayment: paymentData[key].dateOfPayment
    });

    console.log(body);

    if (!window.confirm(`指定した納入状況・入金日で更新します。\n\nよろしいですか？`)) return false;
      
      setIsLoading(true);
      try {
        await updateAnnualFeeStatus(body);
        setIsLoading(false);
        setRefreshCount(refreshCount+1);
      } catch(e) {
        onError(e);
        setIsLoading(false);
      }
      return false;
  };

  const handleAfStatusChange = async (event) => {
    console.log('handleAfStatusChange...' + event.target.value);
    let pds = JSON.parse(JSON.stringify(paymentData));
    const idArr = event.target.id.split('-');
    console.log(idArr[1]);
    pds[idArr[1]].status = event.target.value;
    setPaymentData(pds);
  };

  const handleDateOfPayment = async (event) => {
    console.log('handleDateOfPayment...' + event.target.value);
    const idArr = event.target.id.split('-');
    let pds = JSON.parse(JSON.stringify(paymentData));
    console.log(idArr[1]);
    pds[idArr[1]].dateOfPayment = event.target.value;
    setPaymentData(pds);
  };

  const back = (event) => { 
    console.log(event.target.id);
    history.push('/admin/annualReports');
/*
    if ('backToList' == event.target.id) {
      history.push('/admin?opt=' + opType);
    } else {
      setPage('input');
    }
*/
  };

  const createAnnualFee = (data) => {
    return API.post('sakurajima', '/fees', {
      body: data
    });
  };

  function updateAnnualFeeStatus(statuses) {
    console.log(statuses);
    return API.put("sakurajima", "/annualFeeStatuses", {
	body: statuses
    });
  }

  const availableYears = () => {
    const now = new Date();
    const target = new Date('2021-09-30T00:00:00');
    const ty = target.getFullYear() - ((target-now) < 0 ? 0 : 1);
    let arr = [];
    for (let i=ty; i > (ty - 3); i--) {
	arr.push(i);
    }
    return arr;
  };

  const getMemberTypeLabel = () => {
    return member.memType == 3 ? '正会員' : (member.memType == 6 ? '准会員' : '会員');
  };

  const currentFiscalYear = () => {
      const today = new Date();
      console.log(today);
      const fyp = new Date(Date.parse('' + today.getFullYear() + '-10-01T00:00:00+09:00'));
      console.log(fyp);
      
      return today < fyp ? today.getFullYear() : today.getFullYear()+1;
  };

  return member && (
    <div className="Admin">
      <h1 id="page_title">管理者用　管理画面</h1>
      <div className="container">
        <div id="sub_page">
          <div id="admin" className="top">
              <AdminLeftMenu />
              <section id="contents">
          <h2>{ getMemberTypeLabel() } 年会費納入状況変更画面</h2>
          <h3>会員番号：{ member.memberId }　{ member.familyName } { member.givenName } { member.admissionDate ? '（' + formatJpDateFromString(member.admissionDate) + '入会）' : '' }</h3>
                <div id="report">
                 <Table className="listtbl">
                   <tbody>
                     <tr>
                       <th>年度</th>
                       <th>納入状況</th>
                       <th>入金日</th>
                       <th>処理</th>
                     </tr>
          {fees.map(({pk,sk,data, familyName, givenName, affiliationName, status, dateOfPayment, admissionDate, memType}, index) => (
                  <tr className={ fiscalYear < getMemberId(data, true) ? "admHidden" : "" }>
                       <td>
                  { getMemberId(data, false) }
                       </td>
                       <td>
                  {/* status == 1 ? <span>入金済</span> : */}
                   <Form.Group className="inlineFormSelect inlineFormControl" controlId={"afStatus-" + data} size="sm">
                   <Form.Control
                     as="select"
                     custom
                     size="sm"
                     className="afStatus"
                     name={"afStatus-" + data }
                     value={paymentData[data].status}
                     onChange={ handleAfStatusChange }
                   >
                     <option value="0"></option>
                     <option value="1">入金済</option>
                     <option value="2">未入金</option>
                   </Form.Control>
                 </Form.Group>
                       </td>
                       <td>
                  {/* status == 1 ? dateOfPayment :  */}
                   <Form.Group controlId={"dateOfPayment-" + data} className="inlineFormControl" size="sm">
                     <Form.Control
                       type="text"
                       value={ paymentData[data].dateOfPayment }
                       onChange={handleDateOfPayment}
                     />
                   </Form.Group>
                       </td>
                       <td>
        <LoaderButton
          block
          size="lg"
          type="button"
          isLoading={isLoading}
          disabled={false}
          id={"update-" + data}
          className="rSaveBtn"
          onClick={handleUpdateAnnualFee}
        >
          更新
        </LoaderButton>
                       </td>
                     </tr>
                     ))}
                   </tbody>
                 </Table>
                 <p id="annualFeesErrorMessage" className="errorMessages"></p>
        <div className="opBtns">
          <Button id="backToList" active size="lg" active onClick={ back } >
          戻る
           </Button>
	  {/*          <LoaderButton
            block
            size="lg"
            type="button"
            variant="success"
            isLoading={isLoading}
            id="confirm"
            onClick={handleAddAnnualFee}
          >
            更新
          </LoaderButton>
	   */}
        </div>
               </div>
              </section>
          </div>
        </div>
      </div>
    </div>
  );
}
